import { useEffect, useState } from "react";
import * as api from "../../api";
import HiloEncargo from "./HiloEncargo";
import Icon from "../Icon";
import { etiquetaDia } from "./planes";

// El estado que da quien recibe la tarea, en texto y con simbolo: el color nunca es lo unico.
export function estadoEnviada(e) {
  // Propuestas (T-136): pendientes de que un gestor las apruebe, o rechazadas. Aprobada deja de ser propuesta y sigue su camino.
  if (e.estado === "propuesta") return { clase: "pa", texto: "○ Pendiente de aprobación" };
  if (e.estado === "rechazada") return { clase: "no", texto: "✕ Rechazada" };
  const ap = e.es_propuesta ? "Aprobada · " : "";
  if (e.estado === "hecha") return { clase: "ok", texto: `✓ ${ap}Hecha` };
  if (e.estado === "no_puedo") return { clase: "no", texto: "✕ No puede hacerla" };
  if (e.estado === "planificada") {
    return { clase: "pl", texto: `▦ ${ap}Planificada · ${e.plan?.tipo === "semana" ? "Esta semana" : etiquetaDia(e.plan?.dia) || "con día"}` };
  }
  return { clase: "pl", texto: e.es_propuesta ? "✓ Aprobada · Pendiente" : "Pendiente" };
}

const ESTADOS = [["", "Todos los estados"], ["propuesta", "Pendiente de aprobación"], ["rechazada", "Rechazada"], ["pendiente", "Pendiente"], ["planificada", "Planificada"], ["hecha", "Hecha"], ["no_puedo", "No puede hacerla"]];

// «Enviadas»: lo que mande y como lo lleva cada persona. Solo el estado: nunca el tiempo que dedica.
export default function EnviadasTab({ recarga = 0, onMandar, etiquetaMandar = "Mandar tarea", miId = null, onProponerOtra }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  const [estado, setEstado] = useState("");
  const [hilo, setHilo] = useState(null);
  const [v, setV] = useState(0);

  useEffect(() => {
    let vivo = true;
    api.getEncargosEnviados()
      .then(d => { if (vivo) { setItems(Array.isArray(d?.items) ? d.items : []); setError(""); } })
      .catch(e => { if (vivo) setError(e?.message || "No se han podido cargar las tareas enviadas"); });
    return () => { vivo = false; };
  }, [recarga, v]);

  if (error) {
    return <div className="mt-vacio" role="alert"><b>{error}</b>
      <button type="button" className="btn mt-reintentar" onClick={() => setV(x => x + 1)}>Reintentar</button></div>;
  }
  if (!items) return <p className="mt-estado-pag" role="status">Cargando tus tareas enviadas…</p>;
  if (!items.length) {
    return (
      <div className="mt-vacio">
        <b>{etiquetaMandar === "Proponer tarea" ? "Aún no has propuesto ninguna tarea" : "Aún no has mandado ninguna tarea"}</b>
        {etiquetaMandar === "Proponer tarea"
          ? "Las tareas que propongas aparecerán aquí, con su estado."
          : "Las tareas que mandes a tu equipo aparecerán aquí, con el estado que les dé cada persona."}
        <div><button type="button" className="mt-b p btn" onClick={onMandar}><Icon name="person" size={13} color="currentColor" />{etiquetaMandar}</button></div>
      </div>
    );
  }
  const visibles = estado ? items.filter(e => e.estado === estado) : items;
  return (
    <div>
      {/* El filtro solo sirve con unas cuantas tareas: con una o dos ocupaba una fila entera sin aportar nada */}
      {(items.length > 5 || estado) && (
        <div className="mt-filtros">
          <label htmlFor="mt-env-estado" className="sr-only">Filtrar por estado</label>
          <select id="mt-env-estado" className="mt-inp" value={estado} onChange={e => setEstado(e.target.value)}>
            {ESTADOS.map(([k, t]) => <option key={k} value={k}>{t}</option>)}
          </select>
        </div>
      )}
      {!visibles.length && <div className="mt-vacio-grupo">Ninguna tarea en ese estado.</div>}
      {visibles.map(e => {
        const st = estadoEnviada(e);
        return (
          <div key={e.id} className="mt-fila">
            <div className="mt-cuerpo">
              <div className="mt-titulo">{e.titulo}</div>
              <div className="mt-meta">
                <span className="mt-av" aria-hidden="true">{e.receptor.nombre.split(" ").map(x => x[0]).join("").slice(0, 2)}</span>
                <span>{miId != null && String(e.receptor.id) === String(miId) ? "Para ti" : e.receptor.nombre}</span>
                {e.fecha_limite && <span>Límite {etiquetaDia(e.fecha_limite)}</span>}
                {e.proyecto && <span className="mt-proyecto"><span>{e.proyecto.nombre}</span></span>}
              </div>
              {(e.estado === "no_puedo" || e.estado === "rechazada") && e.motivo && <div className="mt-motivo"><b>Motivo:</b> «{e.motivo}»</div>}
            </div>
            <div className="mt-acc">
              <span className={"mt-est " + st.clase}>{st.texto}</span>
              {e.estado === "rechazada" && onProponerOtra && (
                <button type="button" className="mt-b btn" onClick={() => onProponerOtra(e)}>Proponer otra</button>
              )}
              <button type="button" className="mt-b btn" aria-label={`Conversación: ${e.titulo}${e.mensajes_total ? `, ${e.mensajes_total} comentarios` : ""}`}
                onClick={() => setHilo(e)}><Icon name="chat-dots-fill" size={13} color="currentColor" />{e.mensajes_total ? ` ${e.mensajes_total}` : ""}</button>
            </div>
          </div>
        );
      })}
      {hilo && <HiloEncargo encargoId={hilo.id} titulo={hilo.titulo} onCerrar={() => setHilo(null)} onComentado={() => setV(x => x + 1)} />}
    </div>
  );
}
